module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/381b8964610deccaeba07743f16e8953.png";